import { loadStart, loadStop } from '../Loader';
import GlobalManager from '../global';
export default (function (requestFun) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return new Promise(function (resolve, reject) {
    console.log(requestFun);

    if (!requestFun) {
      reject();
      return;
    }

    var sNeedSubmitPopDiv = true;

    if (params && params.length >= 1 && params[0].forbidLoading) {
      sNeedSubmitPopDiv = false;
    }

    if (sNeedSubmitPopDiv) {
      loadStart('数据加载中');
    }

    requestFun.apply(void 0, params).then(function (res) {
      loadStop();
      resolve(res);
    })["catch"](function (err) {
      loadStop();
      console.log(err);

      if (err && typeof err.isLogin !== 'undefined' && !err.isLogin) {
        err.errCode = -1;
      }

      if (err && err.errCode == '-1') {
        GlobalManager.unLoginCallback(err);
      }

      reject(err);
    });
  });
});